import { Box, Button, Dialog, DialogActions, DialogTitle, Grid, Paper, Typography } from "@material-ui/core";

import { useGiroPrincipal } from "../../context/GiroPrincipalContext";

const GiroPrincipalEliminar = () => {
    const { modalOpenEliminarGiro, handleCloseEliminarGiro, handleClickConfirmarEliminarGiro } = useGiroPrincipal();

    return (
        <Dialog
            open={modalOpenEliminarGiro}
            onClose={handleCloseEliminarGiro}
            maxWidth="sm"
            fullWidth
            PaperComponent={(props) => <Paper square {...props} />}
        >
            <DialogTitle>Confirmación de giro principal</DialogTitle>
            <Box p={3}>
                <Grid container spacing={3} className="center">
                    <Grid item xs={12}>
                        <Typography>¿Desea eliminar el giro principal seleccionado y elegir otra?</Typography>
                    </Grid>
                </Grid>
            </Box>
            <DialogActions>
                <Button variant="contained" color="secondary" onClick={handleCloseEliminarGiro}>
                    Cancelar
                </Button>
                <Button variant="contained" color="primary" onClick={handleClickConfirmarEliminarGiro}>
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default GiroPrincipalEliminar;
